import { create } from './instance'

export const { tw, setup } = /*#__PURE__*/ create()
